<div
  class="lightbox-container"
  (scroll)="checkContentScroll($event)"
  #lbContainer
  [class.scrolled]="contentScrolled"
  [class.info-scrolled]="infoScrolled"
>
  <div class="content-wrapper" [class.full-content]="fullContent">
    <div class="content-wrapper-inner" #innerContentWrapper>
      <ng-template [mbContentHost]></ng-template>
    </div>
  </div>

  <div class="sidebar-wrapper">
    <div class="info-container" (scroll)="checkInfoScroll($event)">
      @if (preMedia && preMedia.formatted_datetimes) {
        <mb-info>
          <div class="embargo-container">
            <div class="embargo-title">
              <wb-icon name="alert-circle"></wb-icon>
              <wb-text size="l" strong static class="embargo-subline">
                {{ 'EMBARGO_CONFIRM_SUBLINE' | translate }}
              </wb-text>
            </div>
            @for (embargoDate of preMedia.formatted_datetimes; track embargoDate) {
              <wb-text size="m" static class="embargo-date">
                {{ embargoDate }}
              </wb-text>
            }
          </div>
        </mb-info>
      }
      @if (sidebarData) {
        <!-- FUEL LABEL -->
        @if (sidebarData.fuelLabel) {
          <p class="fuel-label copy-s" [innerHTML]="sidebarData.fuelLabel"></p>
        }
        @if (sidebarData.displayDate) {
          <div>
            <p class="copy-s">{{ 'PUBLISH_DATE' | translate }}:</p>
            <p class="copy-l">{{ sidebarData.displayDate | localizedDate: 'longDate' }}</p>
          </div>
        }
        @if (sidebarData.caption) {
          <div>
            <p class="copy-s">{{ 'CAPTION' | translate }}:</p>
            <p class="copy-l">{{ sidebarData.caption }}</p>
          </div>
        }
        @if (sidebarData.description) {
          <div>
            <p class="copy-s">{{ 'DESCRIPTION' | translate }}:</p>
            <p class="copy-l">{{ sidebarData.description }}</p>
          </div>
        }
        <!-- SHELF NUMBER -->
        @if (sidebarData.marsShelfNumber) {
          <div>
            <p class="copy-s">{{ 'SHELF_NUMBER' | translate }}:</p>
            <p class="copy-l">{{ sidebarData.marsShelfNumber }}</p>
          </div>
        }
        <!-- MEDIA META -->
        @if (sidebarData.duration) {
          <div>
            <p class="copy-s">{{ 'RUNTIME' | translate }}:</p>
            <p class="copy-l">
              {{ sidebarData.duration | durationFormat }}
            </p>
          </div>
        }
        @if (sidebarData.resolution) {
          <div>
            <p class="copy-s">{{ 'RESOLUTION' | translate }}:</p>
            <p class="copy-l">{{ sidebarData.resolution }}</p>
          </div>
        }
        @if (sidebarData.numberOfPages) {
          <div>
            <p class="copy-s">{{ 'PAGES' | translate }}</p>
            <p class="copy-l">{{ sidebarData.numberOfPages }}</p>
          </div>
        }
        @if (sidebarData.fileSize) {
          <div>
            <p class="copy-s">{{ 'FILE_SIZE' | translate }}:</p>
            <p class="copy-l">{{ sidebarData.fileSize | fileSize }}</p>
          </div>
        }
        <!-- CAPTURES -->
        @if (sidebarData.timecode) {
          <div>
            <p class="copy-s">{{ 'RECORDED_AT' | translate }}:</p>
            <p class="copy-l">{{ sidebarData.timecode }}</p>
          </div>
        }
        @if (sidebarData.numberOfCameras) {
          <div>
            <p class="copy-s">{{ 'AVAILABLE_PERSPECTIVES' | translate }}:</p>
            <p class="copy-l">{{ sidebarData.numberOfCameras }}</p>
          </div>
        }
        <!-- FORMAT -->
        @if (sidebarData.fileFormat) {
          <div>
            <p class="copy-s">{{ 'FILE_FORMAT' | translate }}:</p>
            <p class="copy-l">{{ sidebarData.fileFormat }}</p>
          </div>
        }
        <!-- CONTEXT -->
        @if (contextLink) {
          <div>
            <p class="copy-s">{{ contextLink.label | translate }}:</p>
            <div>
              <a
                [routerLink]="[contextLink.link.url]"
                [queryParams]="contextLink.link.queryParams || {}"
                queryParamsHandling="merge"
                class="copy-l btn btn-plain btn-text"
                (click)="closeLightbox(true)"
              >
                {{ contextLink.text }}
              </a>
            </div>
          </div>
        }
        <!-- DAT LABEL -->
        <p class="dat-label copy-s" [innerHTML]="'DAT_LABEL' | translate"></p>
      }
    </div>

    @if (lightboxService.activeResource) {
      <mb-action-container
        #actionContainerHub
        class="default-action-container large lightbox-action-container"
        [class.in-view]="hubInView"
        [buttonItems]="defaultButtonItems"
        [resource]="lightboxService.activeResource"
      ></mb-action-container>
    }

    @if (lightboxService.activeResource) {
      <mb-action-container
        class="floating-action-container"
        [buttonItems]="floatingActionButtonItems"
        [resource]="lightboxService.activeResource"
      ></mb-action-container>
    }
  </div>

  <div class="lightbox-header" [class.full-width]="showCounter()">
    @if (showCounter()) {
      <div class="counter-container">
        <div class="counter-indicator button-label">{{ lightboxService.activeMediaIndex + 1 }}</div>
        <div class="counter-seperator button-label">/</div>
        <div class="counter-count button-label">{{ lightboxService.mediaCount }}</div>
      </div>
    }

    <div class="close-btn-wrapper">
      <div class="close-btn btn btn-quaternary" (click)="closeLightbox()">
        <span class="d-none d-sm-inline-block">{{ 'CLOSE' | translate }}</span>
        <span class="mb-icon mb-icon-close"></span>
      </div>
    </div>
  </div>
</div>
